import React, { useState, useEffect } from 'react';
import MobileProfileDetails from './MobileProfileDetails';
import { message } from '../../Common/SnakeAlert/SnakeAlert';
import graphqlRequest from '../../../requestMethod';
import { useLocation, useNavigate } from 'react-router-dom';

const MobileProfileDetailsWrapper = () => {
  const [isresumeDownloading, setIsResumeDownloading] = useState(false);
  const [isregistrationDownloading, setIsRegistrationDownloading] = useState(false);
  const [valueToBeMatched, setValueToBeMatched] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { profile, type , selectedRecommendedUser , selectedData , selectedProfiles } = location.state || {};

  useEffect(() => {
    if (profile) {
      if (type === 'application') {
        setSelectedProfile({
          id: profile?.professional?.id,
          jobId: profile?.job?.id
        });
      } else {
        setSelectedProfile({
          id: profile?.id
        });
      }
    }
  }, [profile, type]);

  const handleAccept = async () => {
    try {
      const data = localStorage.getItem("auth");
      const token = JSON.parse(data)?.accessToken;
      console.log("hdhtdhhgghhgfghgh?.id======", selectedProfile?.id , token);
      const query = `
        mutation {
          mutationWithAuth(token: "${token}") {
            update {
              approveApplicationV1(application: "${selectedProfile?.id}")
            }
          }
        }
      `;
      const response = await graphqlRequest(query);
      if (response) {
        console.log("data=====",response);
        
        message.success("Application accepted successfully");
        navigate('/locum/open-jobs');
      }
    } catch (error) {
      message.error("Failed to accept application");
    }
  };

  const handleReject = async () => {
    try {
      const data = localStorage.getItem("auth");
      const token = JSON.parse(data)?.accessToken;
      const query = `
        mutation {
          mutationWithAuth(token: "${token}") {
            update {
              rejectApplication(application: "${selectedProfile?.id}")
            }
          }
        }
      `;
      const response = await graphqlRequest(query);
      if (response) {
        message.success("Application rejected successfully");
        navigate('/locum/open-jobs');
      }
    } catch (error) {
      message.error("Failed to reject application");
    }
  };

  const handleShortlist = async () => {
    try {
      const data = localStorage.getItem("auth");
      const token = JSON.parse(data)?.accessToken;
      const query = `
        mutation {
          mutationWithAuth(token: "${token}") {
            update {
              shortlistApplication(application: "${selectedProfile?.id}")
            }
          }
        }
      `;
      const response = await graphqlRequest(query);
      if (response) {
        message.success("Application shortlisted successfully");
        navigate('/locum/open-jobs');
      }
    } catch (error) {
      message.error("Failed to shortlist application");
    }
  };

  const handleInterview = async () => {
    try {
      const data = localStorage.getItem("auth");
      const token = JSON.parse(data)?.accessToken;
      const query = `
        mutation {
          mutationWithAuth(token: "${token}") {
            update {
              scheduleInterview(application: "${selectedProfile?.id}")
            }
          }
        }
      `;
      const response = await graphqlRequest(query);
      if (response) {
        message.success("Interview scheduled successfully");
        navigate('/locum/open-jobs');
      }
    } catch (error) {
      message.error("Failed to schedule interview");
    }
  };

  const handlejobInvite = async () => {
    try {
      const data = localStorage.getItem("auth");
      const token = JSON.parse(data)?.accessToken;
      const query = `
        mutation {
          mutationWithAuth(token: "${token}") {
            update {
              inviteToApply(jobId: "${selectedProfile?.jobId}", userId: "${selectedProfile?.id}")
            }
          }
        }
      `;
      const response = await graphqlRequest(query);
      if (response) {
        message.success("Invitation sent successfully");
        setValueToBeMatched(true);
        navigate('/locum/open-jobs');
      }
    } catch (error) {
      message.error("Failed to send invitation");
    }
  };

  const handleDownLoadResume = async () => {
    setIsResumeDownloading(true);
    try {
      const data = localStorage.getItem("auth");
      const token = JSON.parse(data)?.accessToken;
      const query = `
        query {
          withAuth(token: "${token}") {
            downloadResume(userId: "${selectedProfile?.id}")
          }
        }
      `;
      const response = await graphqlRequest(query);
      if (response?.data?.withAuth?.downloadResume) {
        const link = document.createElement('a');
        link.href = response.data.withAuth.downloadResume;
        link.download = 'resume.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        message.success("Resume downloaded successfully");
      }
    } catch (error) {
      message.error("Failed to download resume");
    } finally {
      setIsResumeDownloading(false);
    }
  };

  const handleDownloadRegistration = async () => {
    setIsRegistrationDownloading(true);
    try {
      const data = localStorage.getItem("auth");
      const token = JSON.parse(data)?.accessToken;
      const query = `
        query {
          withAuth(token: "${token}") {
            downloadRegistration(userId: "${selectedProfile?.id}")
          }
        }
      `;
      const response = await graphqlRequest(query);
      if (response?.data?.withAuth?.downloadRegistration) {
        const link = document.createElement('a');
        link.href = response.data.withAuth.downloadRegistration;
        link.download = 'registration.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        message.success("Registration certificate downloaded successfully");
      }
    } catch (error) {
      message.error("Failed to download registration certificate");
    } finally {
      setIsRegistrationDownloading(false);
    }
  };

  return (
    <MobileProfileDetails
      handleAccept={handleAccept}
      handleReject={handleReject}
      handleShortlist={handleShortlist}
      handleInterview={handleInterview}
      handlejobInvite={handlejobInvite}
      selectedData={selectedData}
      selectedProfiles={selectedProfiles}
      selectedProfile={selectedProfile}
      selectedRecommendedUser={selectedRecommendedUser}
      handleDownLoadResume={handleDownLoadResume}
      handleDownloadRegistration={handleDownloadRegistration}
      isresumeDownloading={isresumeDownloading}
      isregistrationDownloading={isregistrationDownloading}
      valueToBeMatched={valueToBeMatched}
    />
  );
};

export default MobileProfileDetailsWrapper; 